import { useTheme } from '@mui/material';
import React from 'react';

interface HighlightedTextProps {
  text: string;
  highlightWords?: string[];
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({ text, highlightWords }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const parts = text?.split(/\b/);

  return (
    <span>
      {parts?.map((part, index) => {
        if (highlightWords && highlightWords.includes(part.toLowerCase())) {
          return (
            <span
              key={index}
              style={{
                backgroundColor: isDark ? 'rgba(28, 192, 252, 0.3)' : '#fff176',
                color: isDark ? '#e2e8f0' : '#333',
                borderRadius: '2px',
                padding: '0 1px',
              }}
            >
              {part}
            </span>
          );
        } else {
          return <span key={index}>{part}</span>;
        }
      })}
    </span>
  );
};
